import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CategoryMiniEntity } from '../../domain/entities/CategoryMiniEntity'

export class CategoryMiniModel extends CategoryMiniEntity {
  constructor(dataDto: CategoryMiniEntity) {
    super()
    mapEntityProperties<CategoryMiniModel>(this, dataDto)
  }
}
